import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { Navbar } from "../../components/Navbar";
import { Footer } from "../../components/Footer";

function UserPreferences() {
  const [layout, setLayout] = React.useState(true);
  const theme = useTheme();
  let embed = "https://admin.aprendersteam.com/user/preferences.php";
    // Scroll to top when component mounts
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  function handleContentLayout() {
    setLayout(!layout);
  }
  return (
    <>
      <Navbar layout={layout} handleContentLayout={handleContentLayout} />
      <div className="w-full h-[82px]">

      </div>
      <div
        style={{
          position: "relative",
        paddingTopTop: "280px",
          height: "100dvh",
          padding: "0 0 80px 0",
          transition: "0.1s",
        }}
      >
        {/*  {!iframeLoaded && (
        <div
        className="absolute inset-0 bg-transparent flex items-center justify-center z-10"
        style={{ transition: "background-color 0.1s ease", height: "90%" }}
        >
        <div
        className="size-16 border-[6px] border-gray-300 rounded-full animate-spin"
        style={{
            borderTopColor:
            theme.mode === "light"
            ? theme.colors.button_light
            : theme.colors.button_dark,
            }}
            ></div>
            </div>
            )} */}
        <iframe
          src={embed}
          id="video-player"
          frameBorder="0"
          width="100%"
          allow="autoplay; fullscreen; encrypted-media; accelerometer; gyroscope; microphone; camera"
          height={"99%"}
          title="video"
          style={{
            /* borderBottom: "2px solid #ccc", */ transition: "opacity 0.5s",
            marginBottom: "4px",

            backgroundColor: theme.mode === "light" ? "#FAFAFA" : "#fff",
          }}
        />
      </div>
      <Footer />
    </>
  );
}

export default UserPreferences;
